import ButtonIcon from "components/ButtonIcon";
import Input from "components/Input";
import Label from "components/Label";
import { ModalWrapper } from "./styled"
import { FaRegEdit, FaTrashAlt, FaPlus, FaTimes, FaShare } from "react-icons/fa";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import { useState } from "react";
import { useEffect } from "react";
import { getScheduleApi, createScheduleApi, updateScheduleApi, deleteScheduleApi } from "services/scheduleServices"
import Loading from "components/Loading";
import { tourError } from "errors/tourError"

const ModalSchedule = ({ selectedId, showModal, hidden }) => {
    const [scheduleData, setScheduleData] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [errorTitle, setErrorTitle] = useState("")
    const [initData, setInitData] = useState({
        id: "",
        tour_id: selectedId,
        title: "",
        content: ""
    })

    const [editorState, setEditorState] = useState(EditorState.createWithContent(
        ContentState.createFromBlockArray(
            convertFromHTML('<p></p>')
        )
    ));



    const handleCreate = () => {
        if (initData.title.trim().length > 0) {
            setErrorTitle("")
            if (selectedId) {
                const convert = draftToHtml(convertToRaw(editorState.getCurrentContent()))
                setInitData({ ...initData, content: convert })
                const payload = {
                    tour_id: selectedId,
                    title: initData.title,
                    content: convert
                }
                createData(payload);
            }
        } else {
            setErrorTitle(tourError.requireSchedule)
        }
    }

    const handleUpdate = () => {
        if (initData.title.trim().length > 0) {
            setErrorTitle("")
            if (selectedId) {
                const convert = draftToHtml(convertToRaw(editorState.getCurrentContent()))
                setInitData({ ...initData, content: convert })
                const payload = {
                    tour_id: selectedId,
                    title: initData.title,
                    content: convert
                }
                update(initData.id, payload);
            }
        } else {
            setErrorTitle(tourError.requireSchedule)
        }
    }


    const handelDelete = () => {
        if (initData.id !== "") {
            setErrorTitle("");
            deleteData(initData.id);

        }
    }


    useEffect(() => {
        if (selectedId && showModal) {
            getApi()
            setInitData({
                id: "",
                tour_id: selectedId,
                title: "",
                content: ""
            })
            setEditorState(EditorState.createWithContent(
                ContentState.createFromBlockArray(
                    convertFromHTML('<p></p>')
                )
            ))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedId, showModal])

    function createData(data) {
        const api = async () => {
            setLoading(true)
            const res = await createScheduleApi(data)
            setLoading(false)

            if (res.data.success === true) {
                setScheduleData([...scheduleData, res.data.data])
                resetForm()
            }
        }
        api()
    }


    function update(id, data) {
        const api = async () => {
            const res = await updateScheduleApi(id, data)
            if (res.data.success === true) {
                resetForm()
                getApi()
            }
        }
        api()
    }
    function deleteData(id) {
        const api = async () => {
            setLoading(true)
            const res = await deleteScheduleApi(id)
            setLoading(false)
            if (res.data.success === true) {
                resetForm()
                getApi()
            }
        }
        api()
    }

    function getApi() {
        const api = async () => {
            setLoading(true)
            const res = await getScheduleApi(selectedId)
            setScheduleData(res.data.data)
            setLoading(false)

        }
        api()
    }

    function resetForm() {
        setInitData({
            id: "",
            tour_id: selectedId,
            title: "",
            content: ""
        })
        setErrorTitle("")
        setEditorState(EditorState.createWithContent(
            ContentState.createFromBlockArray(
                convertFromHTML('<p></p>')
            )
        )
        )
    }

    const handleShowDetail = (item) => {
        setInitData({
            id: item.id,
            tour_id: item.tour_id,
            title: item.title,
            content: ""
        })

        setEditorState(item.content !== null
            ? EditorState.createWithContent(
                ContentState.createFromBlockArray(
                    convertFromHTML(item.content)
                )
            )
            : EditorState.createWithContent(
                ContentState.createFromBlockArray(
                    convertFromHTML('<p></p>')
                )
            )
        )
    }

    return (
        <ModalWrapper>
            <div className="amep">
                <div className='amep_overlay'
                    onClick={() => {
                        hidden();
                        setScheduleData([]);
                    }}
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                ></div>
                <div className='amep_container px-50 pb-30'
                    style={
                        showModal ? {
                            transform: 'translateY(0%)',
                            opacity: 1
                        } : {
                            transform: 'translateY(-120%)',
                            opacity: 0
                        }
                    }
                >
                    <h1 className='amep_header'>Lịch trình</h1>
                    <div className="body">
                        <form >
                            <div className="schedule_list">
                                <Label className="mb-5">Danh sách lịch trình:</Label>
                                {
                                    scheduleData.length > 0 &&
                                    scheduleData.map((item, index) => (
                                        <div className="schedule_item" key={index}
                                            onClick={() => handleShowDetail(item)}
                                        >
                                            {item.title}
                                        </div>
                                    ))
                                }

                                {
                                    isLoading &&
                                    < Loading />
                                }
                            </div>
                            <div className="schedule_form bl-grey-1 pl-15">
                                <Label className="mb-5">Lịch trình</Label>
                                <Input
                                    name="title"
                                    onChange={e => setInitData({ ...initData, title: e.target.value })}
                                    value={initData.title}
                                    isError={!!errorTitle}
                                    message={errorTitle}
                                />
                                <div className="control my-5">
                                    <ButtonIcon
                                        icon={<FaTimes />}
                                        onClick={() => resetForm()}
                                        description="Làm mới"
                                        type="button"
                                        classButton="btn-action action-primary mr-10"
                                    />
                                    <ButtonIcon
                                        icon={<FaPlus />}
                                        description="Thêm mới"
                                        type="button"
                                        onClick={handleCreate}
                                        classButton="btn-action action-danger-1 mr-10"
                                    />
                                    {/* <ButtonIcon
                                        icon={<FaRegEdit />}
                                        description='Sửa'
                                        type="button"
                                        onClick={handleUpdate}
                                        classButton="action-danger-2 btn-action mr-10"
                                    /> */}
                                    <ButtonIcon
                                        icon={<FaTrashAlt />}
                                        description='Xóa'
                                        onClick={handelDelete}
                                        type="button"
                                        classButton="action-danger btn-action mr-10"
                                    />
                                </div>
                                <Label className="mt-15">Chi tiết</Label>
                                <div className="b-grey-1">
                                    <Editor
                                        editorState={editorState}
                                        onEditorStateChange={setEditorState}
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="btn_exit">
                        <ButtonIcon type='button'
                            onClick={() => {
                                hidden();
                                setScheduleData([]);
                            }}
                            icon={<FaShare />}
                            classButton="action-primary "
                        >

                            Thoát
                        </ButtonIcon>
                    </div>
                </div>

            </div>
        </ModalWrapper>
    );
}

export default ModalSchedule;